import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import styles from './PaymentSuccess.module.scss';
import content from './PaymentSuccess.json';
import { Button } from '@components';
import { hideModal } from '@store/appStateSlice';
import { TRIMS } from '@constants';
import { getLocalizedContent as l } from '@helpers/languages';

const PaymentSuccess = ({ trim, waitlist = false }) => {
  const dispatch = useDispatch();
  const { language } = useSelector(({ appState }) => appState);
  const handleOk = () => dispatch(hideModal());
  /* eslint-disable react/no-children-prop */
  return (
    <div className={styles.RenameDesignForm}>
      {waitlist ? (
        <Fragment>
          <h4>{l(content.waitlistHeading, language)}</h4>
          <p>{l(content.notify, language)}</p>
          <Button
            className={styles.modalButton}
            children={l(content.button, language)}
            theme="dark"
            type="primary"
            onClick={handleOk}
          />
        </Fragment>
      ) : (
        <Fragment>
          <h4>{l(content.heading, language)}</h4>
          <p>
            {l(content.upgraded, language)} <br />
            <span>{TRIMS[trim]}</span>
          </p>
          <Button
            className={styles.modalButton}
            children={l(content.button, language)}
            theme="dark"
            type="primary"
            onClick={handleOk}
          />
        </Fragment>
      )}
    </div>
  );
};

export default PaymentSuccess;
